import {Consts} from "../pages/consts";
import { useState } from "react";
import {useTranslation} from "react-i18next";

const AddFreeTextDrugDetails = ({onHandleSetFreeDrugDetails, init}) => {
  const { t: t } = useTranslation();
  const [otherProduct, setOtherProduct] = useState('');
  const [otherSubstance, setOtherSubstance] = useState('');

  const setDrugName = (value) => {
    setOtherProduct(value);
    onHandleSetFreeDrugDetails(Consts.PRODUCT, value);
  }

  return (
    <div className="w3-row w3-padding-small"
         style={{ display: 'flex', alignItems: 'center', backgroundColor: init === true ? '#ecd29c' : '#CFE6EF'} }>
      <div className="w3-col s5 w3-mobile">
        <input
          type={Consts.TEXT}
          value={otherProduct}
          onChange={(e) => setDrugName(e.target.value)}
          className="w3-input w3-border w3-round form-input2"
          placeholder={t("medication_name")}
        />
      </div>
      <div className="w3-col s5 w3-mobile">
        <input
          type={Consts.TEXT}
          value={otherSubstance}
          onChange={(e) => setOtherSubstance(e.target.value)}
          onBlur={(e) => onHandleSetFreeDrugDetails(Consts.SUBSTANCE, e.target.value)}
          className="w3-input w3-border w3-round form-input"
          placeholder={t("substances")}
        />
      </div>
    </div>
  );
}

export default AddFreeTextDrugDetails;